function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "no-results");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 250.114655 0 250.114655 167.63748 0 167.63748"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "no-results",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustration",
  transform: "translate(85.000000, 102.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M225,430 C343.741812,430 440,333.741813 440,215 C440,96.2581875 343.741812,0 225,0 C106.258188,0 10,96.2581875 10,215 C10,333.741813 106.258188,430 225,430",
  id: "Illo",
  fill: "#B9D5E0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M343.998516,28.3701699 C333.419585,11.2918939 315.170064,0 294.416257,0 C261.702813,0 235.186341,28.0253619 235.186341,62.5975103 C235.186341,64.134304 235.244681,65.6573967 235.350557,67.1645049 C232.357946,66.3629973 229.227049,65.9336998 226.00108,65.9336998 C222.772951,65.9336998 219.642054,66.3629973 216.649443,67.1645049 C216.755319,65.6573967 216.815819,64.134304 216.815819,62.5975103 C216.815819,28.0253619 190.297187,0 157.585903,0 C136.829936,0 118.578254,11.2918939 108.001484,28.3701699 L18.1540312,165.656309 C7.35902681,181.551733 1,201.039099 1,222.095227 C1,275.615836 42.0538598,319 92.6948762,319 C137.322583,319 174.495772,285.304714 182.697901,240.678328 L188.099725,213.488726 C188.317959,235.41715 205.197577,253.125671 226.00108,253.125671 C246.802423,253.125671 263.684202,235.41715 263.902436,213.488726 L269.30426,240.678328 C277.506389,285.304714 314.679578,319 359.305124,319 C409.94614,319 451,275.615836 451,222.095227 C451,201.039099 444.640973,181.551733 433.845969,165.656309 L343.998516,28.3701699 Z",
  id: "Fill-1",
  fill: "#445C75"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(101.000000, 136.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 138.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Magnify",
  fill: "#7993AD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M91.3610483,0 C141.819454,0 182.723404,40.7427304 182.723404,90.9980462 C182.723404,141.25727 141.819454,182 91.3610483,182 C40.9032964,182 0,141.25727 0,90.9980462 C0,40.7427304 40.9032964,0 91.3610483,0 Z M91.3610487,25.2777778 C54.9194812,25.2777778 25.3782506,54.7024137 25.3782506,90.9986984 C25.3782506,127.296936 54.9194812,156.722222 91.3610487,156.722222 C127.803923,156.722222 157.345154,127.296936 157.345154,90.9986984 C157.345154,54.7024137 127.803923,25.2777778 91.3610487,25.2777778 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.638298,0 C411.096343,0 452,40.7427304 452,90.9980462 C452,141.25727 411.096343,182 360.638298,182 C310.181561,182 269.276596,141.25727 269.276596,90.9980462 C269.276596,40.7427304 310.181561,0 360.638298,0 Z M360.638298,25.2777778 C324.197091,25.2777778 294.654846,54.7024137 294.654846,90.9986984 C294.654846,127.296936 324.197091,156.722222 360.638298,156.722222 C397.080158,156.722222 426.621749,127.296936 426.621749,90.9986984 C426.621749,54.7024137 397.080158,25.2777778 360.638298,25.2777778 Z",
  id: "Combined-Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(21.638298, 9.642384)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.7234043,150.662252 C31.2162314,150.662252 0,119.903324 0,81.9602649 C0,44.0172053 31.2162314,13.2582781 69.7234043,13.2582781 C108.230577,13.2582781 139.446809,44.0172053 139.446809,81.9602649 C139.446809,119.903324 108.230577,150.662252 69.7234043,150.662252 Z",
  id: "Oval",
  fill: "#B5E6E5",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.8972476,90.7654916 C131.264034,90.2378848 148.021317,81.6157076 145.756132,68.3676718 C141.930827,45.9952099 115.717993,30.8927005 90.6394403,30.9541229 C65.3371589,31.0164706 40.8258048,46.6575141 35.1074026,69.2295784 C32.1481001,80.9107376 42.5304608,91.2930984 86.8972476,90.7654916 Z",
  id: "Oval",
  fill: "#FFFFFF",
  opacity: 0.104678199,
  transform: "translate(90.298407, 60.869444) rotate(-315.000000) translate(-90.298407, -60.869444) "
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy",
  transform: "translate(292.117021, 9.642384)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M68.5212766,149.456954 C30.6780205,149.456954 0,119.237657 0,81.9602649 C0,44.682873 30.6780205,14.4635762 68.5212766,14.4635762 C106.364533,14.4635762 137.042553,44.682873 137.042553,81.9602649 C137.042553,119.237657 106.364533,149.456954 68.5212766,149.456954 Z",
  id: "Oval",
  fill: "#B5E6E5",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.6951199,90.7654916 C130.061907,90.2378848 146.819189,81.6157076 144.554004,68.3676718 C140.7287,45.9952099 114.515865,30.8927005 89.4373127,30.9541229 C64.1350312,31.0164706 39.6236771,46.6575141 33.9052749,69.2295784 C30.9459724,80.9107376 41.3283332,91.2930984 85.6951199,90.7654916 Z",
  id: "Oval",
  fill: "#FFFFFF",
  opacity: 0.104678199,
  transform: "translate(89.096280, 60.869444) rotate(-315.000000) translate(-89.096280, -60.869444) "
})), /*#__PURE__*/React.createElement("path", {
  d: "M103.382586,43.3907285 C92.0968756,43.3907285 82.9468085,52.5607335 82.9468085,63.8776467 C82.9468085,75.1953469 92.0968756,84.3708609 103.382586,84.3708609 C114.669867,84.3708609 123.819149,75.1953469 123.819149,63.8776467 C123.819149,52.5607335 114.669867,43.3907285 103.382586,43.3907285",
  id: "Fill-9",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.052799,43.3907285 C357.767088,43.3907285 348.617021,52.5607335 348.617021,63.8776467 C348.617021,75.1953469 357.767088,84.3708609 369.052799,84.3708609 C380.340079,84.3708609 389.489362,75.1953469 389.489362,63.8776467 C389.489362,52.5607335 380.340079,43.3907285 369.052799,43.3907285",
  id: "Fill-9-Copy",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.829362,73.5231788 C126.50982,73.5231788 123.819149,76.2197619 123.819149,79.548603 C123.819149,82.8770179 126.50982,85.5761589 129.829362,85.5761589 C133.14933,85.5761589 135.840426,82.8770179 135.840426,79.548603 C135.840426,76.2197619 133.14933,73.5231788 129.829362,73.5231788",
  id: "Fill-10",
  fill: "#FFFFFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.499575,73.5231788 C392.180032,73.5231788 389.489362,76.2197619 389.489362,79.548603 C389.489362,82.8770179 392.180032,85.5761589 395.499575,85.5761589 C398.819543,85.5761589 401.510638,82.8770179 401.510638,79.548603 C401.510638,76.2197619 398.819543,73.5231788 395.499575,73.5231788",
  id: "Fill-10-Copy",
  fill: "#FFFFFE"
})), /*#__PURE__*/React.createElement("path", {
  d: "M186,209 L216.047069,67.5066369 C218.119752,66.5022123 221.338438,66 225.703125,66 C232.250156,66 235.434377,67.5066369 235.434377,67.5066369 C235.434377,67.5066369 244.622918,114.671091 263,209 L186,209 Z",
  id: "Path-2",
  fill: "#172737"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.50032,177 C203.23685,177 186,194.458182 186,215.997733 C186,237.537284 203.23685,255 224.50032,255 C245.76379,255 263,237.537284 263,215.997733 C263,194.458182 245.76379,177 224.50032,177",
  id: "Fill-7",
  fill: "#7993AD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226,192 C213.297261,192 203,202.295651 203,214.998027 C203,227.701061 213.297261,238 226,238 C238.702739,238 249,227.701061 249,214.998027 C249,202.295651 238.702739,192 226,192",
  id: "Fill-8",
  fill: "#445C75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226,202 C218.820191,202 213,207.819281 213,214.998885 C213,222.17886 218.820191,228 226,228 C233.179809,228 239,222.17886 239,214.998885 C239,207.819281 233.179809,202 226,202",
  id: "Fill-8-Copy",
  fill: "#5A6F85"
}))));

var SvgNoResults = function SvgNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-results.dbc9ed0e.svg";
export { ForwardRef as ReactComponent };